import { motion } from "framer-motion";
import { DownloadFunctionality } from "../../components/downloadFunctionality";

const arrayHref = [
  {
    href: "https://play.google.com/store/apps/details?id=com.imadeabug.hopnflip",
    src: "/GooglePlayBadge.svg",
    alt: "GooglePlay",
  },
  {
    href: "https://apps.apple.com/us/app/ataxx-strategy-board-game/id6737763316",
    src: "/AppStoreBadge.svg",
    alt: "AppStore",
  },
];

export const AtaxxScreen = () => {
  return (
    <div className="flex flex-col sm:flex-row flex-1 justify-center items-center gap-16 sm:gap-4 md:gap-6 lg:gap-10 px-4 sm:px-6 lg:px-12">
      {/* Left - Phone mockup (hidden on mobile) */}
      <div className="hidden sm:flex flex-1 items-end justify-center">
        <motion.img
          src="/ataxx_mobile.png"
          alt="ataxx_mobile"
          className="sm:w-3/4 md:w-3/5 lg:w-1/2 xl:w-1/2"
          whileHover={{
            scale: 1.15,
            rotate: [0, -5, 5, -3, 3, 0],
            rotateY: 15,
            rotateX: 5,
            transition: { duration: 0.6, ease: "easeInOut" },
          }}
          whileTap={{
            scale: 0.95,
            rotateY: 0,
            rotateX: 0,
            transition: { duration: 0.2 },
          }}
        />
      </div>

      {/* Center - Logo + Play button stacked */}
      <div className="flex flex-col items-center justify-center gap-4 sm:gap-4 md:gap-5 lg:gap-6 xl:gap-8 sm:flex-1">
        <img
          src="/logo_Ataxx.png"
          alt="ataxx_logo"
          className="w-28 sm:w-28 md:w-32 lg:w-36 xl:w-40"
        />
        <img
          src="/ataxx_playbutton.png"
          alt="ataxx_play"
          className="w-36 sm:w-36 md:w-40 lg:w-48 xl:w-52"
        />
      </div>

      {/* Right - Download */}
      <div className="flex flex-col items-center justify-center gap-4 sm:gap-5 md:gap-6 lg:gap-8 sm:flex-1">
        <DownloadFunctionality arrayHref={arrayHref} />
      </div>
    </div>
  );
};
